module.exports = "/static/assets/f48637af0d5cab2e44157cfe2537b386.png";